<script setup>
setPageTitle('Add Product')
definePage({ meta: { title: 'Add Product' } })
</script>

<template>
  <VCard>
    <VCardTitle>Add Product</VCardTitle>
    <VCardText>
      <p>Product creation functionality coming soon.</p>
    </VCardText>
  </VCard>
</template>
